import { render, staticRenderFns } from "./ArticleSecondSkeleton.vue?vue&type=template&id=4d51a002&scoped=true"
import script from "./ArticleSecondSkeleton.vue?vue&type=script&lang=js"
export * from "./ArticleSecondSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ArticleSecondSkeleton.vue?vue&type=style&index=0&id=4d51a002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d51a002",
  null
  
)

export default component.exports